<template>
    <div class="language-page">
        <header class="top-nav">
            <button type="button" class="back-btn" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </button>
            <div class="nav-title">{{ $t('safe.language') }}</div>
        </header>

        <main class="page-content">
            <section class="language-group">
                <div class="group-title">{{ getLabel('pageLanguage.groupTitle', '语言设置') }}</div>

                <button
                    v-for="item in languageOptions"
                    :key="item.value"
                    type="button"
                    class="language-item"
                    :class="{ active: lang === item.value }"
                    @click="changeLang(item.value)"
                >
                    <div class="item-left">
                        <div class="flag-box">
                            <img :src="item.icon" :alt="item.label">
                        </div>
                        <div class="item-copy">
                            <strong>{{ item.label }}</strong>
                            <span>{{ item.subLabel }}</span>
                        </div>
                    </div>
                    <div class="item-right">
                        <van-icon v-if="lang === item.value" name="success" class="success-icon" />
                        <van-icon v-else name="arrow" class="arrow-icon" />
                    </div>
                </button>
            </section>
        </main>
    </div>
</template>

<script>
import { Toast, Icon } from "vant";
import Vue from "vue";

Vue.use(Icon);
Vue.use(Toast);

export default {
    name: "language",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            appOriginalStyles: null,
            bodyOriginalBackground: "",
        };
    },
    computed: {
        languageOptions() {
            return [
                {
                    value: "zh_cn",
                    label: this.$t("lang.zh_cn"),
                    subLabel: "Chinese (Simplified)",
                    icon: require("../images/language/zh_cn.png"),
                },
                {
                    value: "en_us",
                    label: this.$t("lang.en_us"),
                    subLabel: "English",
                    icon: require("../images/language/en_us.png"),
                },
                {
                    value: "ja_jp",
                    label: this.$t("lang.ja_jp"),
                    subLabel: "Japanese",
                    icon: require("../images/language/ja_jp.png"),
                },
                {
                    value: "ko_kr",
                    label: this.$t("lang.ko_kr"),
                    subLabel: "Korean",
                    icon: require("../images/language/ko_kr.png"),
                },
                {
                    value: "vi_vn",
                    label: this.$t("lang.vi_vn"),
                    subLabel: "Vietnamese",
                    icon: require("../images/language/vi_vn.png"),
                },
                {
                    value: "ms_my",
                    label: this.$t("lang.ms_my"),
                    subLabel: "Malay",
                    icon: require("../images/language/ms_my.png"),
                },
                {
                    value: "th_th",
                    label: this.$t("lang.th_th"),
                    subLabel: "Thai",
                    icon: require("../images/language/th_th.png"),
                },
                {
                  value: "spanish",
                  label: 'Español',
                  subLabel: "México",
                  icon: require("../images/language/spanish.png"),
                },
            ];
        },
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        this.applyFullScreenLayout();
    },
    beforeDestroy() {
        this.restoreFullScreenLayout();
    },
    methods: {
        getLabel(key, defaultText) {
            return this.$te(key) ? this.$t(key) : defaultText;
        },
        applyFullScreenLayout() {
            const app = document.getElementById("app");
            if (!app) {
                return;
            }
            this.appOriginalStyles = {
                maxWidth: app.style.maxWidth,
                width: app.style.width,
                margin: app.style.margin,
                backgroundColor: app.style.backgroundColor,
                paddingBottom: app.style.paddingBottom,
            };
            this.bodyOriginalBackground = document.body.style.background;
            app.style.maxWidth = "100%";
            app.style.width = "100%";
            app.style.margin = "0";
            app.style.backgroundColor = "#000000";
            app.style.paddingBottom = "0";
            document.body.style.background = "#000000";
        },
        restoreFullScreenLayout() {
            const app = document.getElementById("app");
            if (app && this.appOriginalStyles) {
                app.style.maxWidth = this.appOriginalStyles.maxWidth || "";
                app.style.width = this.appOriginalStyles.width || "";
                app.style.margin = this.appOriginalStyles.margin || "";
                app.style.backgroundColor = this.appOriginalStyles.backgroundColor || "";
                app.style.paddingBottom = this.appOriginalStyles.paddingBottom || "";
            }
            document.body.style.background = this.bodyOriginalBackground || "";
        },
        changeLang(lang) {
            if (this.lang === lang) {
                return;
            }
            Toast.loading({
                duration: 200,
            });
            this.lang = lang;
            this.$i18n.locale = lang;
            localStorage.setItem("lang", lang);
            setTimeout(() => {
                this.$router.go(-1);
            }, 300);
        },
    },
};
</script>

<style lang="less" scoped>
.language-page {
    min-height: 100vh;
    background: #000;
    color: #fff;
}

.top-nav {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    padding: 0 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.9);
    backdrop-filter: blur(12px);
}

.back-btn {
    position: absolute;
    left: 16px;
    top: 50%;
    width: 28px;
    height: 28px;
    margin-top: -14px;
    border: 0;
    background: transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.back-btn .van-icon {
    font-size: 22px;
}

.nav-title {
    font-size: 18px;
    font-weight: 700;
}

.page-content {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 24px 14px 30px;
    box-sizing: border-box;
}

.language-group {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.03);
    backdrop-filter: blur(12px);
}

.language-group {
    overflow: hidden;
    margin-bottom: 18px;
}

.group-title {
    padding: 16px 16px 10px;
    color: rgba(255, 255, 255, 0.74);
    font-size: 13px;
    font-weight: 700;
}

.language-item {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px;
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    background: transparent;
    color: #fff;
    text-align: left;
}

.language-item:first-of-type {
    border-top: 0;
}

.language-item.active {
    background: rgba(45, 91, 255, 0.06);
}

.item-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
    flex: 1;
}

.flag-box {
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: rgba(45, 91, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
}

.flag-box img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
}

.item-copy {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.item-copy strong {
    color: #fff;
    font-size: 15px;
    font-weight: 700;
}

.item-copy span {
    color: rgba(255, 255, 255, 0.48);
    font-size: 12px;
    line-height: 1.5;
}

.item-right {
    flex-shrink: 0;
}

.success-icon {
    color: #2d5bff;
    font-size: 20px;
}

.arrow-icon {
    color: rgba(255, 255, 255, 0.35);
    font-size: 18px;
}

</style>
